import React, { useState } from 'react';
import {
	Popover,
	Button,
	MenuItem,
	Box
} from '@material-ui/core';

import TranslationHelper from '../../../../common/TranslationHelper';

export default function Sort(props) {
	const sortTypes = [
		{
			title: TranslationHelper.getValue('customer_account.searchResult.sort'),
			sortFilters: [
				{
					filterTitle: TranslationHelper.getValue('customer_account.searchResult.sort.low'),
					type: 'price-asc',
					filterHTML: '<i class="fas fa-sort-numeric-up"></i>'
				}, {
					filterTitle: TranslationHelper.getValue('customer_account.searchResult.sort.high'),
					type: 'price-desc',
					filterHTML: '<i class="fas fa-sort-numeric-down"></i>'
				}
			]
		}
	];
	const { searchParams } = props;
	const [currentFilterActive, setCurrentFilterActive] = useState(searchParams && searchParams.sortType
		? searchParams.sortType
		: sortTypes[0].sortFilters[0].type);
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelect = (data) => {
		const { sortCb, mobileModalVisible, setMobileModalVisibility } = props;
		setCurrentFilterActive(data);
		const filters = sortTypes.flatMap((sortType) => (sortType.sortFilters));
		const foundFilter = filters.find((sort) => sort.type === data);
		if (mobileModalVisible) {
			setMobileModalVisibility(false);
		}
		sortCb(foundFilter);
	};

	const createDropdownOptions = (params = { title: '', sortFilters: [] }) => {
		const { title, sortFilters } = params;

		return (
			sortFilters.map((sort, key) => (
				<MenuItem
					// eslint-disable-next-line react/no-array-index-key
					key={`sortSelectOption${key}`}
					onClick={() => { handleSelect(sort.type); handleClose(); }}
					selected={currentFilterActive === sort.type}
				>
					{`${title} - ${sort.filterTitle}`}
				</MenuItem>
			))
		);
	};

	return (
		<Box display="flex" justifyContent="center" alignItems="center">
			<Popover
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				disableScrollLock
			>
				<div>{ sortTypes.map((params, key) => createDropdownOptions(params, key)) }</div>
			</Popover>
			<Button
				variant="outlined"
				size="small"
				onClick={handleClick}
				style={{ outline: 0, padding: '5px 8px', color: '#c4c4c4' }}
			>
				{currentFilterActive === 'price-asc'
					? 'Low'
					: 'High'}
				{currentFilterActive === 'price-asc'
					? (
						<i
							className="fas fa-sort-amount-up"
							style={{
								color: '#c4c4c4', fontSize: '18px', marginLeft: '5px', padding: '2px'
							}}
						/>
					)
					: (
						<i
							className="fas fa-sort-amount-down"
							style={{
								color: '#c4c4c4', fontSize: '18px', marginLeft: '5px', padding: '2px'
							}}
						/>
					)}
			</Button>
		</Box>
	);
}
